import { decode, encode } from "@googlemaps/polyline-codec";
export const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
export const number = (value) =>
  Number.isFinite(Number(value)) ? Number(value) : 0;
export const sport = (a) => a.sport_type || a.type || "Activity";
export const sportLabel = (value) => value.replace(/([a-z])([A-Z])/g, "$1 $2");
export const distance = (meters, units) =>
  (number(meters) / (units === "mi" ? 1609.344 : 1000)).toLocaleString(
    undefined,
    { maximumFractionDigits: 1 },
  );
export const duration = (seconds) => {
  const minutes = Math.round(number(seconds) / 60);
  return `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
};
export const yearOf = (a) =>
  Number((a.start_date_local || a.start_date || "").slice(0, 4));
export function summarize(activities) {
  const months = MONTHS.map((label) => ({ label, distance: 0, count: 0 }));
  const types = {};
  const days = new Set();
  let meters = 0,
    seconds = 0,
    elevation = 0,
    kudos = 0,
    prs = 0,
    longest = null,
    hrSeconds = 0,
    hrTotal = 0,
    maxHr = 0,
    group = 0;
  activities.forEach((a) => {
    const d = number(a.distance),
      t = number(a.moving_time);
    meters += d;
    seconds += t;
    elevation += number(a.total_elevation_gain);
    kudos += number(a.kudos_count);
    prs += number(a.pr_count);
    if (!longest || d > number(longest.distance)) longest = a;
    types[sport(a)] = (types[sport(a)] || 0) + 1;
    const local = a.start_date_local || a.start_date || "";
    if (local) days.add(local.slice(0, 10));
    const month = Number(local.slice(5, 7)) - 1;
    if (months[month]) {
      months[month].distance += d;
      months[month].count += 1;
    }
    if (number(a.average_heartrate) > 0 && t > 0) {
      hrTotal += a.average_heartrate * t;
      hrSeconds += t;
    }
    maxHr = Math.max(maxHr, number(a.max_heartrate));
    if (number(a.athlete_count) > 1) group++;
  });
  return {
    meters,
    seconds,
    elevation,
    kudos,
    prs,
    longest,
    months,
    types,
    activeDays: days.size,
    averageHr: hrSeconds ? Math.round(hrTotal / hrSeconds) : null,
    maxHr,
    group,
  };
}
export function routePoints(activity, size = 200) {
  try {
    const coords = decode(activity?.map?.summary_polyline || "", 5);
    if (coords.length < 2) return "";
    const xs = coords.map((p) => p[1]),
      ys = coords.map((p) => -p[0]);
    const minX = Math.min(...xs),
      minY = Math.min(...ys),
      width = Math.max(...xs) - minX,
      height = Math.max(...ys) - minY;
    const span = Math.max(width, height);
    if (!span) return "";
    const scale = (size * 0.78) / span;
    return coords
      .map(
        (p, i) =>
          `${((xs[i] - minX) * scale + (size - width * scale) / 2).toFixed(2)},${((ys[i] - minY) * scale + (size - height * scale) / 2).toFixed(2)}`,
      )
      .join(" ");
  } catch {
    return "";
  }
}
export function demoActivities(year) {
  const names = [
    "The long way home",
    "Morning miles",
    "A little fresh air",
    "Sunday loop",
    "Golden hour ride",
    "One more hill",
  ];
  return Array.from({ length: 108 }, (_, i) => {
    const type = i % 4 === 0 ? "Ride" : i % 7 === 0 ? "Hike" : "Run";
    const month = 1 + Math.floor(i / 9),
      day = 1 + ((i * 3) % 27);
    const points = Array.from({ length: 36 }, (_, j) => {
      const t = (j / 35) * Math.PI * 2;
      return [
        37.7 + Math.sin(t) * (0.01 + 0.002 * Math.sin(t * 3 + i)) + j * 0.00006,
        -122.4 + Math.cos(t) * (0.012 + 0.004 * Math.sin(t * 2 + i)),
      ];
    });
    return {
      id: i + 1,
      name: names[i % 6],
      sport_type: type,
      type,
      start_date_local: `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}T07:30:00Z`,
      distance: type === "Ride" ? 18000 + i * 120 : 3200 + i * 73,
      moving_time: 1600 + i * 34,
      total_elevation_gain: 35 + i * 2,
      kudos_count: i % 12,
      pr_count: i % 11 === 0 ? 1 : 0,
      average_heartrate: 130 + (i % 25),
      max_heartrate: 165 + (i % 15),
      athlete_count: i % 5 === 0 ? 3 : 1,
      map: { summary_polyline: encode(points, 5) },
    };
  });
}
